import { z } from "zod";
import { IsoDateTimeSchema } from "./common";
import { AudiobookIdSchema, BookIdSchema, ChapterIdSchema } from "./ids";
import { BookLanguageSchema } from "./states";

export const AudiobookChapterSchema = z.strictObject({
  chapterId: ChapterIdSchema,
  position: z.int().positive(),
  number: z.int().positive(),
  title: z.string(),
  durationMs: z.int().nonnegative(),
  /** Chapter mark inside the M4B. */
  startMs: z.int().nonnegative(),
  renderedAt: IsoDateTimeSchema,
  /** This Chapter's script changed after the Audiobook was assembled. */
  stale: z.boolean(),
});
export type AudiobookChapter = z.infer<typeof AudiobookChapterSchema>;

/** GET /books/:id/audiobook; 404 NOT_FOUND until the first assembly finished. */
export const AudiobookSchema = z.strictObject({
  id: AudiobookIdSchema,
  bookId: BookIdSchema,
  title: z.string(),
  authorName: z.string().nullable(),
  narratorName: z.string().nullable(),
  language: BookLanguageSchema,
  createdAt: IsoDateTimeSchema,
  durationMs: z.int().nonnegative(),
  /** A newer Chapter Audio or a changed script exists; still downloadable until re-assembled. */
  stale: z.boolean(),
  /** A re-assembly is running. */
  assembling: z.boolean(),
  coverPresent: z.boolean(),
  m4b: z.strictObject({ sizeBytes: z.int().nonnegative() }),
  zip: z.strictObject({ sizeBytes: z.int().nonnegative() }),
  chapters: z.array(AudiobookChapterSchema),
});
export type Audiobook = z.infer<typeof AudiobookSchema>;
